import * as React from 'react';

import { Navbar, NavbarGroup } from '@blueprintjs/core';
import SubNavMenuItem from '../layout/SubNavMenuItem';

import './AdminNavBar.scss';
// import Authorization from 'src/util/Authorization';
// import { UserRoles } from 'src/models/UserRole';
import UserDetails from 'src/models/UserDetails';

interface IAdminNavBarProps {
    location: string;
    matchUrl: string;
    user: UserDetails;
    navigate: (path: string) => void;
}

class AdminNavBar extends React.Component<IAdminNavBarProps> {
    public render() {
        const subNavProps = {
            location: this.props.location,
            navigate: this.props.navigate,
            section: 'admin',
        };

        const { matchUrl } = this.props;

        return (
            <Navbar className="admin-nav-bar">
                <NavbarGroup>
                    <SubNavMenuItem name="Users" path={`${matchUrl}/users`} {...subNavProps} />
                    <SubNavMenuItem name="Offices" path={`${matchUrl}/offices`} {...subNavProps} />
                    <SubNavMenuItem name="Clients" path={`${matchUrl}/clients`} {...subNavProps} />
                    {/* {Authorization.IsInRole(UserRoles.Admin, this.props.user) && (<SubNavMenuItem name="Config" path={`${matchUrl}/config`} {...subNavProps} />)} */}
                </NavbarGroup>
            </Navbar>
        );
    }
}

export default AdminNavBar;



// WEBPACK FOOTER //
// ./src/components/admin/AdminNavBar.tsx